var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#8BE22C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.736 9.751a.91.91 0 0 0-1.272 0L12.68 20.356 8.536 16.28a.91.91 0 0 0-1.272 0 .875.875 0 0 0 0 1.251l4.78 4.702a.911.911 0 0 0 1.274 0l11.418-11.23a.875.875 0 0 0 0-1.252Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success_icon.8f6d3276fb36608d60755187660a25be.svg";
export { ForwardRef as ReactComponent };